module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stanislaw Lem\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Stanislaw Lem (1921-2006) was the most widely translated and best known science fiction author writing outside of the English language. Winner of the Kafka Prize, he was a contributor to many magazines, including the "), _c('I', [_vm._v("New Yorker,")]), _vm._v(" and the author of numerous works, including "), _c('I', [_vm._v("Solaris.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/kqG3aQ/tc-custom/9780544003088.jpg?1721057546865",
      "alt": "This image is the cover for the book Imaginary Magnitude"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Imaginary Magnitude\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("These wickedly authentic introductions to twenty-first-century books preface tomes on teaching English to bacteria, using animated X-rays to create \"pornograms,\" and analyzing computer-generated literature through the science of \"bitistics.\" \"Lem, a science fiction Bach, plays in this book a googleplex of variations on his basic themes\" (New York Times Book Review). Translated by Marc E. Heine. A Helen and Kurt Wolff Book"), _c('br')]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Houghton Mifflin Harcourt (www.hmhco.com)\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0